import React, { useEffect } from 'react';
import { useFirebaseMessaging } from '@/shared/hooks/useFirebaseMessaging';
import { MessagePayload } from 'firebase/messaging';

interface FirebaseMessagingInitializerProps {
  userId?: string;
  enabled?: boolean;
  onMessage?: (payload: MessagePayload) => void;
  onTokenReceived?: (token: string) => void;
  autoRegister?: boolean;
  useCustomBanner?: boolean;
}

/**
 * Component to initialize Firebase messaging for authenticated users
 * This component should be placed in authenticated areas of the app
 */
const FirebaseMessagingInitializer: React.FC<FirebaseMessagingInitializerProps> = ({
  userId,
  enabled = true,
  onMessage,
  onTokenReceived,
  autoRegister = true,
  useCustomBanner = true
}) => {
  const { fcmToken, notificationPermission, isInitialized, isSupported, error, registerToken } =
    useFirebaseMessaging({
      onMessage,
      onTokenReceived,
      userId,
      autoRegister,
      useCustomBanner
    });

  useEffect(() => {
    // Log messaging status for debugging
    if (isInitialized && isSupported) {
      console.log('Firebase messaging initialized successfully');
      console.log('FCM Token:', fcmToken);
      console.log('Notification permission:', notificationPermission);
    }

    if (error) {
      console.error('Firebase messaging error:', error);
    }
  }, [isInitialized, isSupported, fcmToken, notificationPermission, error]);

  // Note: Automatic permission requests removed for Safari compatibility
  // Use NotificationPermissionBanner or manual user gesture to request permissions

  // This component doesn't render anything
  return null;
};

export default FirebaseMessagingInitializer;
